import { ActionTypes } from '../../constants/ActionTypes';
import { IBpmReducer } from '../../interfaces/Bpm';

const INIT_STATE: IBpmReducer = {
  bpmCaseUrl: '',
  bpmNewCaseUrl: '',
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.SET_BPM_URL: {
      return {
        ...state,
        bpmCaseUrl: action.payload,
      };
    }
    case ActionTypes.GET_BPM_NEW_CASE_URL: {
      return {
        ...state,
        params: action.payload,
      };
    }
    case ActionTypes.FETCH_BPM_NEW_CASE_URL_SUCCESS: {
      return {
        ...state,
        bpmNewCaseUrl: action.payload,
      };
    }

    default:
      return state;
  }
};
